"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var model_1 = require("../shared/model");
var shared_1 = require("@formily/shared");
var normalizeMessages = function (messages) { return shared_1.toArr(messages).filter(function (v) { return !!v; }); };
exports.Form = model_1.createModel((_a = (function () {
        function FormStateFactory() {
            this.state = {
                valid: true,
                invalid: false,
                loading: false,
                validating: false,
                initialized: false,
                submitting: false,
                editable: true,
                modified: false,
                errors: [],
                warnings: [],
                values: {},
                initialValues: {},
                mounted: false,
                unmounted: false
            };
        }
        FormStateFactory.prototype.produce = function (draft, dirtys) {
            if (dirtys.errors) {
                draft.errors = normalizeMessages(draft.errors);
            }
            if (dirtys.warnings) {
                draft.warnings = normalizeMessages(draft.warnings);
            }
            if (draft.errors.length) {
                draft.invalid = true;
                draft.valid = false;
            }
            else {
                draft.invalid = false;
                draft.valid = true;
            }
            if (dirtys.initialized && !draft.modified) {
                if (dirtys.values) {
                    draft.modified = true;
                }
            }
            if (dirtys.initialValues) {
                draft.values = shared_1.defaults(draft.initialValues, draft.values);
            }
            if (dirtys.validating) {
                if (draft.validating === true) {
                    draft.loading = true;
                }
                else if (draft.validating === false) {
                    draft.loading = false;
                }
            }
            if (draft.mounted === true && dirtys.mounted) {
                draft.unmounted = false;
            }
            if (draft.unmounted === true && dirtys.unmounted) {
                draft.mounted = false;
            }
        };
        return FormStateFactory;
    }()),
    _a.displayName = 'FormState',
    _a));
